import React, { Component } from 'react';
import {
  Icon
} from '../components';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Default max file upload size for client side validation.
 * Unit is Byte, 5MB. 
 */
const maxFileSize = 5000000;

class FileUploadFormField extends Component {

  render() {
    return (
      <Dropzone
        ref={this.props.inputRef}
        className={classNames('form-item file-upload file-upload-large js', this.props.className, this.props.validationMessage ? 'has-error' : null)}
        inputProps={{
          id: this.props.styleName,
          name: this.props.styleName,
          className: 'form-control inputfile inputfile-5'
        }}
        aria-invalid={this.props.validationMessage ? 'true' : 'false'}
        accept={this.props.accept}
        maxSize={this.props.maxSize}
        multiple={this.props.multiple}
        disablePreview={this.props.disablePreview}
        onDrop={this.props.onFileDrop}
        disableClick={true}>
        <label htmlFor={this.props.styleName} className={this.props.file ? 'filled' : ''}>
          <figure>
            <Icon icon='upload' />
          </figure>
          <span>
            {
              this.props.file ? this.props.file.name : this.props.dropLabel
            }
          </span>
        </label>
        <span id='preview-image-help-block' className='help-block'>
          {this.props.validationMessage}
        </span>
      </Dropzone>
    );
  }
}

FileUploadFormField.propTypes = {
  inputRef: PropTypes.func,
  className: PropTypes.string,
  styleName: PropTypes.string,
  accept: PropTypes.string,
  maxSize: PropTypes.number,
  multipe: PropTypes.bool,
  onFileDrop: PropTypes.func.isRequired,
  file: PropTypes.object,
  dropLabel: PropTypes.string.isRequired,
  validationMessage: PropTypes.string,
  allowPreview: PropTypes.bool
};

FileUploadFormField.defaultProps = {
  className: 'file-upload-5',
  maxSize: maxFileSize,
  multipe: false,
  allowPreview: true
};

export default FileUploadFormField;



// WEBPACK FOOTER //
// ./src/containers/components/file-upload-form-field.js